import React, { useEffect, useState } from "react";

import PretendardText from "../../atoms/text/pretendardText";

import Popup from "../../molecules/popup";

import PopupOverLay from "../PopupOverlay";

import ReviewGrade from "../../../pages/shopping/shoppingReview/_components/reviewGrade";
import moment from "moment";
import GrayBtn from "../../atoms/button/grayBtn";
import RedBtn from "../../atoms/button/redBtn";
import ReviewApi from "../../../api/review.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import Modal from "../Modal";

const ReviewDetailPopup = ({
  setPopupOpen,
  detailData,
  getReviewList,
  isWriteAuthority,
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteHandler = async () => {
    try {
      await ReviewApi.delete(detailData.id);

      setDeleteModalOpen(false);
      toast(toastMsg.delete);
      await getReviewList();

      setPopupOpen(false);
    } catch (error) {
      errorHandler(error);
    }
  };

  const [activationFilter, setActivationFilter] = useState(
    detailData.activation
  );
  const [bestFilter, setBestFilter] = useState(detailData.bestFlag);

  const activationChangeFunc = async (value) => {
    try {
      const data = {
        activation: value,
      };

      await ReviewApi.updateActivation(detailData.id, data);

      toast(toastMsg.update);
      getReviewList();
      setActivationFilter(value);
    } catch (error) {
      errorHandler(error);
    }
  };

  const bestFlagChangeFunc = async (value) => {
    try {
      const data = {
        bestFlag: value,
      };

      await ReviewApi.update(detailData.id, data);

      toast(toastMsg.update);
      getReviewList();
      setBestFilter(value);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <PopupOverLay
        isOpen={true}
        onClick={() => {
          setPopupOpen(false);
        }}
      >
        <Popup
          headerTitle="후기 상세보기"
          onClick={() => {
            setPopupOpen(false);
          }}
          noFooter={true}
          // footerBtnText="저장하기"
          // footerBtnHandler={() => {}}
        >
          {/* 본문 영역 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "24px 30px",
            }}
          >
            <PretendardText
              style={{
                fontWeight: "400",
                fontSize: "13px",
                lineHeight: "20.25px",
                color: "#aaa",
                marginBottom: 5,
              }}
            >
              {detailData?.merchTitle}
            </PretendardText>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                marginBottom: 13,
                height: 24,
              }}
            >
              <ReviewGrade rating={detailData?.score} />
              <PretendardText
                style={{
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "22px",
                  letterSpacing: "-0.3%",
                  color: "#aaa",
                }}
              >
                {detailData?.member.nickname}
              </PretendardText>
              <PretendardText
                style={{
                  fontWeight: "500",
                  fontSize: "13px",
                  lineHeight: "18.75px",
                  color: "rgba(181, 181, 181, 0.5)",
                }}
              >
                {moment(detailData?.createdAt).format("YYYY-MM-DD HH:mm")}
              </PretendardText>
            </div>
            <div
              className="custom-scrollbar"
              style={{
                width: "100%",
                maxHeight: 400,
                overflowY: "auto",
              }}
            >
              <PretendardText
                style={{
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "20.25px",
                  color: "#aaa",
                }}
              >
                {detailData?.content}
              </PretendardText>
            </div>
            {isWriteAuthority ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  marginTop: 40,
                }}
              >
                {bestFilter ? (
                  <GrayBtn
                    onClick={() => {
                      bestFlagChangeFunc(false);
                    }}
                  >
                    베스트 후기에서 제외
                  </GrayBtn>
                ) : (
                  <GrayBtn
                    onClick={() => {
                      bestFlagChangeFunc(true);
                    }}
                  >
                    베스트 후기로 지정
                  </GrayBtn>
                )}
                {activationFilter ? (
                  <GrayBtn
                    onClick={() => {
                      activationChangeFunc(false);
                    }}
                  >
                    숨기기
                  </GrayBtn>
                ) : (
                  <GrayBtn
                    onClick={() => {
                      activationChangeFunc(true);
                    }}
                  >
                    숨김 풀기
                  </GrayBtn>
                )}
                <RedBtn
                  onClick={() => {
                    setDeleteModalOpen(true);
                  }}
                >
                  삭제
                </RedBtn>
              </div>
            ) : null}
          </div>

          <div
            style={{
              width: "100%",
              height: 0.5,
              background: "rgba(255, 255, 255, 0.12)",
            }}
          />

          {/* 답글달기 */}
          {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "24px 30px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  marginBottom: 8,
                }}
              >
                <PretendardText
                  style={{
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "22px",
                    letterSpacing: "-0.3%",
                    color: "#aaa",
                  }}
                >
                  제디피트
                </PretendardText>
                <PretendardText
                  style={{
                    fontWeight: "500",
                    fontSize: "13px",
                    lineHeight: "18.75px",
                    color: "rgba(181, 181, 181, 0.5)",
                  }}
                >
                  2024-06-30 20:48
                </PretendardText>
              </div>

              <div
                className="custom-scrollbar"
                style={{
                  width: "100%",
                  maxHeight: 200,
                  overflowY: "auto",
                  marginBottom: 22,
                }}
              >
                <PretendardText
                  style={{
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "20.25px",
                    color: "#aaa",
                  }}
                >
                  감사합니다! 큰 도움이 되셨으면 좋겠어요
                </PretendardText>
              </div>

              <div
                style={{
                  width: "fit-content",
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  marginBottom: 32,
                }}
              >
                <BlueBtn onClick={() => {}}>수정</BlueBtn>
                <RedBtn onClick={() => {}}>삭제</RedBtn>
              </div>

              <PretendardText
                style={{
                  fontWeight: "500",
                  fontSize: "15px",
                  lineHeight: "21.5px",
                  color: "#aaa",
                  marginBottom: 12,
                }}
              >
                답글달기
              </PretendardText>
              <TextArea
                type={"text"}
                placeholder={"내용을 입력해주세요"}
                value={""}
                onChange={(e) => {
                  console.log(e.target.value);
                }}
                style={{
                  width: "100%",
                  minHeight: "107px",
                }}
              />
            </div> */}
        </Popup>
      </PopupOverLay>

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteHandler}
        />
      )}
    </>
  );
};

export default ReviewDetailPopup;
